import React, { Component } from 'react';
import { Spin, Table, Tooltip, Button, Card, Icon, InputNumber, Col, Row, Modal, Select, Pagination } from 'antd';
import { sanitizerTexto } from '../../util/utilerias';
import { openNotification } from '../../util/notificaciones';
import CatalogoRequest from '../../services/Catalogo';
import { get_id } from '../../util/IdUser';
import InventarioRequest from '../../services/Inventario';
import { roles } from '../../util/Roles';
import { withRouter } from "react-router";
import { Link } from 'react-router-dom';
import { esBarras, getSegmento } from '../../util/generics';
const rol = localStorage.getItem("role")?.split(",");
const { confirm } = Modal;
const { Option } = Select;
const exceptThisSymbols = ["e", "E", "+", "-"];
/**
 * Evento para cancelar el scroll en input number
 */
document.addEventListener("wheel", function (event) {
    if (document.activeElement.type === "number") {
        document.activeElement.blur();
    }
});

/**
 * Clase para ver el proceso de mostrar artículos del inventario
 */
export default class CapturarInventarioPT extends Component {
    state = {
        esBarra: esBarras(),
        arrArticulosInventario: [],
        filterText: "",
        cargando: false,
        bloquear_guardar: true,
        arrDrives: [],
        driveSelected: undefined,
        scroll: { x: 1050, y: 500 },
        disable_combo_drive: false,
        mostrar_modal_articulos: false,
        mostrar_modal_succes: false,
        arr_articulos_error: [],
        mostrar_variacion: false,
        paginacion: {},
        pageSize: 100,
        totalArticulos: 0,
        arrArticulosVista: [],
        mostrar_modal_po: false,
        arr_pedidos: [],
        sucursal: "",
        totalArticulosRec: 0,
        arrArticulosVistaRec: [],
        ventaNeta: 0,
        difereniaNeta: 0,
        difereniaPrcnt: 0
    }

    /**
     * Comportamiento del componente al mostrar los artículos
     */
    componentDidMount = () => {
        let state = { ...this.state };
        const segmento = getSegmento()
        if (!segmento) {
            const location = {
                pathname: "/",
            }
            this.setState(state, this.props.history.push(location))
        } else {
            const script = document.createElement("script");

            script.src = "https://kit.fontawesome.com/a076d05399.js";
            script.async = true;
            script.crossorigin = 'anonymous';
            document.body.appendChild(script);

            let idSitio = this.props.match.params.idSitio;

            this.setState({ cargando: true }, () => {
                if (this.props.match.params.idInvent !== undefined) {
                    CatalogoRequest.CargarSitiosByUsuario(get_id()).then(response => {
                        state.arrDrives = response.data;
                        if (response.data.length === 1) {
                            this.setState({ sucursal: response.data[0].nombre }, this.onChangeDrive)
                            this.setState({ driveSelected: response.data[0].id }, this.onChangeDrive)
                        }
                        else {
                            let elSitio = response.data.find((item) => item.id == (idSitio * 1));
                            if (elSitio != undefined) {
                                this.setState({ sucursal: elSitio.nombre }, this.onChangeDrive);
                                this.setState({ driveSelected: elSitio.id }, this.onChangeDrive);
                            } else {
                                this.setState({ cargando: false });
                                const mensaje = state.esBarra
                                    ? "El usuario no tiene asignada una barra, deberá configurarla en el módulo de usuarios."
                                    : "El usuario no tiene asignado un punto de venta, deberá configurarlo en el módulo de usuarios."
                                openNotification(
                                    mensaje,
                                    "Aviso"
                                )
                            }
                        }
                        if (!response.data.length) {
                            if (rol.includes(roles.Operador)) {
                                const mensaje = state.esBarra
                                    ? "El usuario no tiene asignada una barra, favor de contactar al Administrador."
                                    : "El usuario no tiene asignado un punto de venta, favor de contactar al Administrador."
                                openNotification(
                                    mensaje,
                                    "Error"
                                )
                            } else {
                                const advertencia = state.esBarra
                                    ? "El usuario no tiene asignada una barra, deberá configurarla en el módulo de usuarios."
                                    : "El usuario no tiene asignado un punto de venta, deberá configurarlo en el módulo de usuarios."
                                openNotification(
                                    advertencia,
                                    "Aviso"
                                )
                            }
                        }
                    }).catch(err => {
                        const mensajeError = state.esBarra
                            ? "Ha ocurrido un error al listar las barras del usuario."
                            : "Ha ocurrido un error al listar los puntos de venta del usuario."
                        openNotification(
                            mensajeError,
                            "Error"
                        )
                    })

                } else {
                    InventarioRequest.PedidoSugerido(idSitio).then(response => {
                        state.arr_pedidos = response.data.pedidos;
                        if (state.arr_pedidos.length > 0) {
                            state.mostrar_modal_po = true;
                            state.cargando = false;
                            state.driveSelected = idSitio;
                            this.setState(state)
                        } else {
                            CatalogoRequest.CargarSitiosByUsuario(get_id()).then(response => {
                                state.arrDrives = response.data;
                                if (response.data.length === 1) {
                                    this.setState({ sucursal: response.data[0].nombre }, this.onChangeDrive)
                                    this.setState({ driveSelected: response.data[0].id }, this.onChangeDrive)
                                }
                                else {
                                    let elSitio = response.data.find((item) => item.id == (idSitio * 1));
                                    if (elSitio != undefined) {
                                        this.setState({ sucursal: elSitio.nombre }, this.onChangeDrive);
                                        this.setState({ driveSelected: elSitio.id }, this.onChangeDrive);
                                    } else {
                                        this.setState({ cargando: false });
                                        const aviso = state.esBarra
                                            ? "El usuario no tiene asignada esta barra, deberá configurarla en el módulo de usuarios."
                                            : "El usuario no tiene asignado este punto de venta, deberá configurarlo en el módulo de usuarios."
                                        openNotification(
                                            aviso,
                                            "Aviso"
                                        )
                                    }
                                }
                                if (!response.data.length) {
                                    if (rol.includes(roles.Operador)) {
                                        const error = state.esBarra
                                            ? "El usuario no tiene asignada una barra, favor de contactar al Administrador."
                                            : "El usuario no tiene asignado un punto de venta, favor de contactar al Administrador."
                                        openNotification(
                                            error,
                                            "Error"
                                        )
                                    } else {
                                        const avisoError = state.esBarra
                                            ? "El usuario no tiene asignada una barra, deberá configurarla en el módulo de usuarios."
                                            : "El usuario no tiene asignado un punto de venta, deberá configurarlo en el módulo de usuarios."
                                        openNotification(
                                            avisoError,
                                            "Aviso"
                                        )
                                    }
                                }
                            }).catch(err => {
                                const error = state.esBarra
                                    ? "Ha ocurrido un error al listar las barras del usuario."
                                    : "Ha ocurrido un error al listar los puntos de venta del usuario."
                                openNotification(
                                    error,
                                    "Error"
                                )
                            })


                        }
                    }).catch(err => {
                        this.setState({ cargando: false });
                        console.log(err)
                        openNotification(
                            "Ha ocurrido un error al consultar el estatus de los pedidos.",
                            "Error"
                        )
                    })
                }
            })
        }
    }

    componentWillReceiveProps(props) {
        //this.componentDidMount();
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        state.filterText = value;
        let arrEquivalenciasCopy = state.arrEquivalencias
        if (value) {
            arrEquivalenciasCopy = arrEquivalenciasCopy.filter(obj => {
                return sanitizerTexto(value, obj.articulo.codigo)
                    || sanitizerTexto(value, obj.articulo.descripcion)
            })
        }
        state.arrEquivalenciasCopy = arrEquivalenciasCopy
        this.setState(state);
    }

    /**
     * Se ejecuta cuando se busca en el input text
     */
    handleSearchInput = (text) => {
        let state = { ...this.state };
        state.filterText = text;
        this.setState(state);

        clearTimeout(state.timer)
        state.timer = setTimeout(() => {
            this.applyFilters();
        }, 1000);
    }

    /**
     * Función que se ejecuta cuando se da clic en página siguiente
     * @param: paginaSiguiente. valor de la página siguiente
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };
        state.paginaSiguiente = paginaSiguiente
        this.setState({ cargando: true }, () => {
            if (state.driveSelected) {
                InventarioRequest.ListarArticulosInventarioPT(state.driveSelected, this.props.match.params.esExterno).then(response => {
                    state.paginacion = {
                        current: paginaSiguiente,
                    }
                    state.bloquear_guardar = false;
                    state.cargando = false;

                    state.disableRange = false;

                    this.setState(state)
                }).catch(err => {
                    this.setState({ cargando: false });
                    openNotification(
                        "Ha ocurrido un error al listar el histórico del drive seleccionado.",
                        "Error"
                    )
                })
            }
        })
    }

    /**
     * Se ejecuta cuando se cambia un drive
     */
    onChangeDrive = () => {
        let state = { ...this.state };
        if (state.driveSelected) {
            this.setState({ cargando: true, arrArticulosInventario: [], bloquear_guardar: true, mostrar_variacion: false }, () => {
                if (this.props.match.params.idInvent !== undefined) {
                    InventarioRequest.ListarDetalleInventarioEdit(this.props.match.params.idInvent).then(response => {
                        let invStatus = 0;
                        if (response.data.articulos.length) {
                            state.bloquear_guardar = false;
                            invStatus = response.data.inventario.Estatus;
                        }
                        state.cargando = false;
                        state.arrArticulosInventario = response.data.articulos.sort((a, b) => a.codigo - b.codigo);
                        state.totalArticulos = response.data.articulos.length;
                        const pageSize = state.pageSize;
                        state.arrArticulosVista = state.arrArticulosInventario.filter((item, index) => {
                            if (pageSize >= index) {
                                return true;
                            }
                        })
                        if (invStatus == 2) {
                            state.arr_articulos_error = response.data.articulos.sort((a, b) => a.codigo - b.codigo);
                            state.arrArticulosVistaRec = state.arr_articulos_error.filter((item, index) => {
                                if (pageSize >= index) {
                                    return true;
                                }
                            })
                            state.ventaNeta = response.data.inventario.VentaNeta;
                            this.calculoDifenrencia(state);
                            state.totalArticulos = 0;
                            state.totalArticulosRec = response.data.articulos.length;
                            state.mostrar_modal_articulos = true;
                            state.bloquear_guardar = false;
                            state.arrArticulosVista = [];
                            state.arrArticulosInventario = [];
                        }
                        this.setState(state)
                    }).catch(err => {
                        this.setState({ cargando: false });
                        openNotification(
                            err?.response?.data?.cuerpo,
                            err?.response?.data?.titulo ?? 'Error'
                        )
                    })
                } else {
                    InventarioRequest.ListarArticulosInventarioPT(state.driveSelected, this.props.match.params.esExterno).then(response => {
                        if (response.data.length) {
                            state.bloquear_guardar = false;
                        }
                        state.cargando = false;
                        state.arrArticulosInventario = response.data;
                        state.totalArticulos = response.data.length;
                        const pageSize = state.pageSize;
                        state.arrArticulosVista = state.arrArticulosInventario.filter((item, index) => {
                            if (pageSize >= index) {
                                return true;
                            }
                        })
                        this.setState(state)
                    }).catch(err => {
                        this.setState({ cargando: false });
                        openNotification(
                            err?.response?.data?.cuerpo,
                            err?.response?.data?.titulo ?? 'Error'
                        )
                    })
                }
            })
        } else {
            this.setState({ arrArticulosInventario: [], bloquear_guardar: true })
        }
    }

    calculoDifenrencia = (state) => {
        let difMonto = 0;
        state.arr_articulos_error.filter(item => {
            if (item.diferencia !== 0) {
                difMonto = difMonto + (item.diferencia * item.ult_costo)
                return true;
            }
        })
        state.difereniaNeta = difMonto;
        state.difereniaPrcnt = difMonto / state.ventaNeta * 100;
    }

    /**
     * Acción que se ejecuta al ingresar cantidad
     * @param: value. valor que recibe desde el input
     * @param: record. objeto sobre el que se ejecuta la acción
     */
    onChangeCantBodegaArticulo = (value, record) => {
        let state = { ...this.state };
        state.arrArticulosVista.filter(item => {
            item.bordeRojo = false;
            if (item.id === record.id) {
                item.conteoBodega = value
                return true;
            }
        });
        this.setState(state);
    }

    onChangeCantCocinaArticulo = (value, record) => {
        let state = { ...this.state };
        state.arrArticulosVista.filter(item => {
            item.bordeRojo = false;
            if (item.id === record.id) {
                item.conteoCocina = value

                item.conteo = item.conteoBodega + item.conteoCocina
                return true;
            }
        });
        this.setState(state);
    }

    onChangeCantBodega = (value, record) => {
        let state = { ...this.state };
        state.arr_articulos_error.filter(item => {
            item.bordeRojo = false;
            if (item.id === record.id) {
                if (value === "" || value === undefined || value === null){
                    item.conteoBodega = value;
                    
                    if (!isNaN(parseInt(item.conteoCocina)))
                        item.conteo = item.conteoCocina
                    else item.conteo = 0
                } else {
                    item.conteoBodega = value;
                    item.conteo = item.conteoBodega + item.conteoCocina
                }
                item.diferencia = item.conteo - item.existencia
                return true;
            }
        });
        this.calculoDifenrencia(state);
        this.setState(state);
    }

    onChangeCantCocina = (value, record) => {
        let state = { ...this.state };
        state.arr_articulos_error.filter(item => {
            item.bordeRojo = false;
            if (item.id === record.id) {
                if (value === "" || value === undefined || value === null){
                    item.conteoCocina = value;
                    
                    if (!isNaN(parseInt(item.conteoBodega)))
                        item.conteo = item.conteoBodega
                    else item.conteo = 0
                } else {
                    item.conteoCocina = value;
                    item.conteo = item.conteoBodega + item.conteoCocina
                }
                item.diferencia = item.conteo - item.existencia
                return true;
            }
        });
        this.calculoDifenrencia(state);
        this.setState(state);
    }

    /**
     * Comportamiento al confirmar categorización
     * @param: nada.
     * @return: nada.
     */
    showConfirm = (value) => {
        let state = { ...this.state }
        let mostrar_error = false;
        let tipoError = 1;
        let errorEmpty = false;
        for (let index = 0; index < state.arrArticulosInventario.length; index++) {
            const element = state.arrArticulosInventario[index];
            if (!isNaN(parseInt(element.conteoBodega)) && !isNaN(parseInt(element.conteoCocina))) {
                element.conteo = element.conteoBodega + element.conteoCocina;
            }else{
                element.conteo = '';
                errorEmpty = true;
            }
        }
        if (!mostrar_error) {
            for (let index = 0; index < state.arrArticulosInventario.length; index++) {
                const element = state.arrArticulosInventario[index];
                if (element.error) {
                    mostrar_error = true;
                    tipoError = 2;
                    break;
                }
            }
        }

        this.setState(state);
        if (errorEmpty && value === 2) {
            openNotification(
                "Es necesario capturar todos los articulos antes de procesar el inventario.",
                "Aviso"
            )
        } else {
            confirm({
                title: 'Confirmar',
                //content: <div><b>¿Está seguro que las cantidades capturadas son las correctas? Solo se podrá editar 30 minutos después de que se haya guardado.</b></div>,
                content: <div><b>¿Está seguro que las cantidades capturadas son las correctas?</b></div>,
                okText: 'Aceptar',
                cancelText: 'Cancelar',
                okButtonProps: {
                    id: 'boton-aceptar-confirmacion-capturar-inventario-form',
                },
                cancelButtonProps: {
                    id: 'boton-cancelar-confirmacion-capturar-inventario-form',
                },
                onOk: () => {
                    this.setState({ guardando: true, bloquearBotones: true }, this.guardarInventarioArticulos(value))
                },
            });
        }
    }

    showConfirmProcces = () => {
        let state = { ...this.state }
        let errorEmpty = false;
        for (let index = 0; index < state.arr_articulos_error.length; index++) {
            const element = state.arr_articulos_error[index];
            if (!isNaN(parseInt(element.conteoBodega)) && !isNaN(parseInt(element.conteoCocina))) {
                element.conteo = element.conteoBodega + element.conteoCocina;
            }else{
                element.conteo = '';
                errorEmpty = true;
                if (!isNaN(parseInt(element.conteoBodega)))
                    element.conteo = element.conteoBodega
                if (!isNaN(parseInt(element.conteoCocina)))
                    element.conteo = element.conteoCocina
            }
        }

        this.setState(state);
        if (errorEmpty) {
            openNotification(
                "Es necesario capturar todos los articulos antes de procesar el inventario.",
                "Aviso"
            )
        } else {
            confirm({
                title: 'Confirmar',
                content: <div><b>¿Estas seguro que las cantidades capturadas son correctas y deseas contabilizar el inventario (fin de proceso)?</b></div>,
                okText: 'Aceptar',
                cancelText: 'Cancelar',
                okButtonProps: {
                    id: 'boton-aceptar-confirmacion-capturar-inventario-form',
                },
                cancelButtonProps: {
                    id: 'boton-cancelar-confirmacion-capturar-inventario-form',
                },
                onOk: () => {
                    this.setState({ guardando: true, bloquearBotones: true }, this.proccesInventarioArticulos())
                },
            });
        }
    }

    /**
     * Función para guardar la captura de inventario de artículos auxiliares
     */
    guardarInventarioArticulos = (value) => {
        let state = { ...this.state };
        let obj_enviar = {}

        const now = new Date()
        const utcTimeOffset = now.getTimezoneOffset() / 60;

        obj_enviar.usuario_creacion = get_id();
        obj_enviar.sitio_id = state.driveSelected
        obj_enviar.articulos = state.arrArticulosInventario
        obj_enviar.externo = this.props.match.params.esExterno;
        obj_enviar.status = value;
        obj_enviar.time_zone = utcTimeOffset;
        if (this.props.match.params.idInvent !== undefined) {
            obj_enviar.id = state.arrArticulosInventario[0].inventario.id
            //UPDATE Inventario
            this.setState({ cargando: true, bloquear_guardar: true }, () => {
                InventarioRequest.GuardarEdicionInventarioPT(obj_enviar).then(response => {
                    state.bloquear_guardar = true;
                    const pageSize = state.pageSize;
                    if( response.data.titulo == "Éxito" || response.data.titulo == "Aviso"){
                        if(response.data.variacion && response.data.variacion.length > 0) {
                            state.arr_articulos_error = response.data.variacion.sort((a,b) => a.codigo - b.codigo);
                            state.arrArticulosVistaRec = state.arr_articulos_error.filter((item,index)=>{
                                if(pageSize >= index){
                                    return true;
                                }
                            })
                            state.ventaNeta = response.data.inventario.VentaNeta;
                            this.calculoDifenrencia(state);
                            state.totalArticulos = 0;
                            state.totalArticulosRec = response.data.variacion.length;
                            state.mostrar_modal_articulos = true;
                            state.bloquear_guardar = false;
                            state.arrArticulosVista = [];
                            state.arrArticulosInventario = [];
                        }
                    }
                    state.cargando = false;
                    state.arrArticulosVista = [];
                    openNotification(
                        response?.data?.cuerpo,
                        response?.data?.titulo
                    )
                    const location = {
                        pathname: "/capturar_inventario_pt/true/" + obj_enviar.sitio_id,
                    }
                    if(state.mostrar_modal_articulos)
                        this.setState(state)
                    else
                        this.setState(state, this.props.history.push(location))
                }).catch(err => {
                    if (err?.response?.data?.articulos?.length) {
                        this.setState({
                            cargando: false,
                            bloquear_guardar: false,
                            mostrar_modal_articulos: false,
                            arr_articulos_error: err.response.data.articulos
                        })
                    } else {
                        this.setState({ cargando: false, bloquear_guardar: false, mostrar_modal_articulos: false })
                        openNotification(
                            err?.response?.data?.cuerpo,
                            err?.response?.data?.titulo ?? 'Error'
                        )
                    }
                })
            })
        } else {
            //CREATE Inventario
            this.setState({ cargando: true, bloquear_guardar: true }, () => {
                InventarioRequest.GuardarCapturaInventarioPT(obj_enviar).then(response => {
                    state.bloquear_guardar = true;
                    const pageSize = state.pageSize;
                    if (response.data.titulo == "Éxito" || response.data.titulo == "Aviso") {
                        if (response.data.variacion && response.data.variacion.length > 0) {
                            state.arr_articulos_error = response.data.variacion.sort((a, b) => a.codigo - b.codigo);
                            state.arrArticulosVistaRec = state.arr_articulos_error.filter((item, index) => {
                                if (pageSize >= index) {
                                    return true;
                                }
                            })
                            state.ventaNeta = response.data.inventario.VentaNeta;
                            this.calculoDifenrencia(state);
                            state.totalArticulos = 0;
                            state.totalArticulosRec = response.data.variacion.length;
                            state.mostrar_modal_articulos = true;
                            state.bloquear_guardar = false;
                            state.arrArticulosVista = [];
                            state.arrArticulosInventario = [];
                        }
                    }
                    state.cargando = false;
                    state.arrArticulosVista = [];
                    const location = {
                        pathname: "/capturar_inventario_pt/true/" + obj_enviar.sitio_id,
                    }

                    openNotification(
                        response?.data?.cuerpo,
                        response?.data?.titulo
                    )
                    if (state.mostrar_modal_articulos)
                        this.setState(state)
                    else
                        this.setState(state, this.props.history.push(location))
                }).catch(err => {
                    if (err?.response?.data?.articulos?.length) {
                        this.setState({
                            cargando: false,
                            bloquear_guardar: false,
                            mostrar_modal_articulos: false,
                            arr_articulos_error: err.response.data.articulos
                        })
                    } else {
                        this.setState({ cargando: false, bloquear_guardar: false, mostrar_modal_articulos: false })
                        openNotification(
                            err?.response?.data?.cuerpo,
                            err?.response?.data?.titulo ?? 'Error'
                        )
                    }
                })
            })
        }
    }

    /**
     * Función para guardar la captura de inventario de artículos auxiliares
     */
    updateInventarioArticulos = () => {
        let state = { ...this.state };
        let obj_enviar = {}
        obj_enviar.usuario_creacion = get_id();
        obj_enviar.sitio_id = state.driveSelected
        obj_enviar.articulos = state.arrArticulosInventario
        obj_enviar.externo = this.props.match.params.esExterno;
        obj_enviar.status = 2;
        obj_enviar.id = state.arrArticulosInventario[0].inventario.id
        //UPDATE Inventario
        this.setState({ cargando: true, bloquear_guardar: true }, () => {
            InventarioRequest.GuardarEdicionInventarioPT(obj_enviar).then(response => {
                state.bloquear_guardar = true;
                if (response.data.titulo == "Éxito" || response.data.titulo == "Aviso") {
                    if (response.data.variacion && response.data.variacion.length > 0) {
                        state.arr_articulos_error = response.data.variacion;
                        state.mostrar_modal_articulos = true;
                        state.bloquear_guardar = false;
                    }
                }
                state.cargando = false;
                state.arrArticulosVista = [];
                this.setState(state)
            }).catch(err => {
                if (err?.response?.data?.articulos?.length) {
                    this.setState({
                        cargando: false,
                        bloquear_guardar: false,
                        mostrar_modal_articulos: false,
                        arr_articulos_error: err.response.data.articulos
                    })
                } else {
                    this.setState({ cargando: false, bloquear_guardar: false, mostrar_modal_articulos: false })
                    openNotification(
                        err?.response?.data?.cuerpo,
                        err?.response?.data?.titulo ?? 'Error'
                    )
                }
            })
        })
    }

    proccesInventarioArticulos = () => {
        let state = { ...this.state };
        let obj_enviar = {}
        obj_enviar.usuario_creacion = get_id();
        obj_enviar.sitio_id = state.driveSelected
        obj_enviar.articulos = state.arr_articulos_error
        obj_enviar.externo = this.props.match.params.esExterno;
        obj_enviar.status = 3;
        obj_enviar.id = state.arr_articulos_error[0].inventario.id
        //UPDATE Inventario
        this.setState({ cargando: true, bloquear_guardar: true }, () => {
            InventarioRequest.ProcessInventario(obj_enviar).then(response => {
                state.cargando = false;
                state.arrArticulosVista = [];
                state.bloquear_guardar = true;
                state.mostrar_modal_articulos = false;
                openNotification(
                    response?.data?.cuerpo,
                    response?.data?.titulo
                )
                this.setState(state)
            }).catch(err => {
                if (err?.response?.data?.articulos?.length) {
                    this.setState({
                        cargando: false,
                        bloquear_guardar: false,
                        mostrar_modal_articulos: false,
                        arr_articulos_error: err.response.data.articulos
                    })
                } else {
                    this.setState({ cargando: false, bloquear_guardar: false, mostrar_modal_articulos: false })
                    openNotification(
                        err?.response?.data?.cuerpo,
                        err?.response?.data?.titulo ?? 'Error'
                    )
                }
            })
        })
    }

    onChangePagination = (page, size) => {
        let state = { ...this.state };
        const inicio = (page * size) - size;
        const fin = (page * size);
        const tabla = document.querySelector('.ant-table-body');
        if (tabla) tabla.scrollTop = 0;
        state.arrArticulosVista = [];
        state.arrArticulosVista = state.arrArticulosInventario.filter((item, index) => {
            if (index >= inicio && index < fin) {
                return true;
            }
        })
        this.setState(state)
    }

    onChangePaginationRec = (page, size) => {
        const tabla = document.querySelector('#divTable .ant-table-body');
        if (tabla) tabla.scrollTop = 0;
        let state = { ...this.state };
        const inicio = (page * size) - size;
        const fin = (page * size);
        state.arrArticulosVistaRec = [];
        state.arrArticulosVistaRec = state.arr_articulos_error.filter((item, index) => {
            if (index >= inicio && index < fin) {
                return true;
            }
        })
        this.setState(state)
    }

    financial(x) {
        return Number.parseFloat(x).toFixed(2);
    }

    getRowClassName = (record, index) => {
        if (record.diferencia < 0) {
            return 'row-error'; // Apply a class for error rows
        }
        if (record.diferencia > 0) {
            return 'row-even'; // Apply a class for even rows
        }
        return ''; // No specific class for other rows
    };

    getPorcentaje = (record, index) => {
        if (record.existencia < 0) {
            return this.financial((record.diferencia / record.existencia * 100) * -1)
        }
        if (record.existencia == 0) {
            return this.financial(record.diferencia * 100)
        }
        return this.financial(record.diferencia / record.existencia * 100)
    };

    currencyFormat(num) {
        return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    render() {
        const columnasArticulos = [
            {
                title: "Código PT",
                dataIndex: "codigo",
                key: "codigo",
                width: 150,
                render: (_, record) => (
                    <div>
                        {
                            <span className={this.state.mostrar_variacion && record.variacion != 0 || record.error ? "textRojo" : ""}>
                                {record.codigo}
                            </span>
                        }
                    </div>
                )
            },
            {
                title: "Descripción",
                dataIndex: "descripcion",
                key: "descripcion",
                render: (_, record) => (
                    <div>
                        {<span className={this.state.mostrar_variacion && record.variacion != 0 || record.error ? "textRojo" : ""} >{record.descripcion}</span>
                        }
                    </div>
                )
            },
            {
                title: "Bodega",
                dataIndex: "conteoBodega",
                key: "conteoBodega",
                width: 150,
                render: (_, record) => (
                    <InputNumber
                        type="number"
                        onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                        formatter={value => String(value).replace(/[,.-]$/, '')}
                        parser={value => String(value).replace(/[,.-]$/, '')}
                        min={0}
                        max={99999}
                        maxLength={7}
                        precision={0}
                        className={this.state.mostrar_variacion && record.variacion != 0 || record.error ? "textRojo" : ""}
                        onChange={(cant) => this.onChangeCantBodegaArticulo(cant, record)}
                        value={record.conteoBodega}
                        disabled={this.state.mostrar_variacion}
                    />
                )
            },
            {
                title: "Cocina",
                dataIndex: "conteoCocina",
                key: "conteoCocina",
                width: 150,
                render: (_, record) => (
                    <InputNumber
                        type="number"
                        onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                        formatter={value => String(value).replace(/[,.-]$/, '')}
                        parser={value => String(value).replace(/[,.-]$/, '')}
                        min={0}
                        max={99999}
                        maxLength={7}
                        precision={2}
                        className={this.state.mostrar_variacion && record.variacion != 0 || record.error ? "textRojo" : ""}
                        onChange={(cant) => this.onChangeCantCocinaArticulo(cant, record)}
                        value={record.conteoCocina}
                        disabled={this.state.mostrar_variacion}
                    />
                )
            },
            {
                title: "Unidad",
                dataIndex: "unidad",
                key: "unidad",
                width: 150,
                render: (_, record) => (
                    <span className={this.state.mostrar_variacion && record.variacion != 0 ? "textRojo" : ""}>
                        {record.unidad}
                    </span>
                )
            }
        ];
        let columnasCodigos = [
            {
                title: "Código PT",
                dataIndex: "codigo",
                key: "codigo",
                width: 100
            },
            {
                title: "Descripción",
                dataIndex: "descripcion",
                key: "descripcion"
            },
            {
                title: "Unidad",
                dataIndex: "unidad",
                key: "unidad",
                width: 90
            },
            {
                title: "Existencia actual",
                dataIndex: "existencia",
                key: "existencia",
                render: existencia => {
                    return (
                        <div style={{ textAlign: "right", marginRight: "5px" }}>
                            <span>
                                {this.financial(existencia)}
                            </span>
                        </div>
                    )
                }
            },
            {
                title: "Conteo Bodega",
                dataIndex: "conteoBodega",
                key: "conteoBodega",
                render: (_, record) => (
                    <InputNumber
                        style={{ textAlign: "right", border: (record.conteoBodega  === "" || record.conteoBodega === undefined || record.conteoBodega === null) ? "2px solid red" : "none"}}
                        type="number"
                        onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                        formatter={value => String(value).replace(/[,.-]$/, '')}
                        parser={value => String(value).replace(/[,.-]$/, '')}
                        min={0}
                        max={99999}
                        maxLength={7}
                        precision={0}
                        onChange={(cant) => this.onChangeCantBodega(cant, record)}
                        value={record.conteoBodega}
                        disabled={this.state.mostrar_variacion}
                    />
                )
            },
            {
                title: "Conteo Cocina",
                dataIndex: "conteoCocina",
                key: "conteoCocina",
                render: (_, record) => (
                    <InputNumber
                        style={{ textAlign: "right", border: (record.conteoCocina  === "" || record.conteoCocina === undefined || record.conteoCocina === null) ? "2px solid red" : "none"}}
                        type="number"
                        onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                        formatter={value => String(value).replace(/[,.-]$/, '')}
                        parser={value => String(value).replace(/[,.-]$/, '')}
                        min={0}
                        max={99999}
                        maxLength={7}
                        precision={2}
                        onChange={(cant) => this.onChangeCantCocina(cant, record)}
                        value={record.conteoCocina}
                        disabled={this.state.mostrar_variacion}
                    />
                )
            },
            {
                title: (
                    <Tooltip title="Suma de conteo de bodega + cocina​">
                        <span>Conteo Total</span>
                    </Tooltip>
                ),
                dataIndex: "conteo",
                key: "conteo",
                width: 100,
                render: conteo => {
                    return (
                        <div style={{ textAlign: "right", marginRight: "5px" }}>
                            <span>
                                {this.financial(conteo)}
                            </span>
                        </div>
                    )
                }
            },
            {
                title: (
                    <Tooltip title="Conteo total – Inventario inicial en unidades​​">
                        <span>Diferencias en unidades</span>
                    </Tooltip>
                ),
                dataIndex: "diferencia",
                key: "diferencia",
                //width: 170,
                render: diferencia => {
                    return (
                        <div style={{ textAlign: "right", marginRight: "5px" }}>
                            <span>
                                {this.financial(diferencia)}
                            </span>
                        </div>
                    )
                }
            },
            {
                title: (
                    <Tooltip title="Porcentaje de diferencia entre inventario inicial​​​">
                        <span>% Dif</span>
                    </Tooltip>
                ),
                dataIndex: "dif_porcnt",
                key: "dif_porcnt",
                width: 85,
                render: (value, record) => {
                    return (
                        <div style={{ textAlign: "right", marginRight: "5px" }}>
                            <span>
                                {this.getPorcentaje(record)}%
                            </span>
                        </div>
                    )
                }
            }
        ];
        let columnPedidos = [
            {
                title: "Número Pedido",
                dataIndex: "pedido_sap",
                key: "pedido_sap"
            },
            {
                title: "Estatus",
                dataIndex: "estatus",
                key: "estatus"
            }
        ]

        return (
            <Card id="ParentSize"
                title={
                    <div>
                        <Tooltip placement="top" title="Regresar">
                            <Link to={"/capturar_inventario_pt/true/" + this.state.driveSelected}>
                                <Icon type="arrow-left" style={{ fontSize: '22px', strokeWidth: "30", color: '#91ba43' }} theme="outlined" />
                            </Link>
                        </Tooltip> &nbsp; Captura de inventario
                    </div>
                }
                extra={
                    <div>
                        <Button className="btnVerCrearGuardar"
                            style={{
                                backgroundColor: this.state.bloquear_guardar ? '#f5f5f5' : '#76BDFF',
                                borderColor: this.state.bloquear_guardar ? '#d9d9d9' : '#76BDFF',
                                color: this.state.bloquear_guardar ? '#b8b8b8' : '#000'
                            }}
                            disabled={this.state.bloquear_guardar}
                            type="primary"
                            id="boton-guardar-inventario-modulo"
                            onClick={() => { this.showConfirm(0) }}
                        > Guardar Borrador </Button>&nbsp;
                        <Button className="btnVerCrearGuardar"
                            disabled={this.state.bloquear_guardar}
                            type="primary"
                            id="boton-guardar-inventario-modulo"
                            onClick={() => { this.showConfirm(2) }}
                        > Registrar Inventario </Button>
                    </div>
                }
            >
                <div className="panel-block" >
                    <div style={{ marginBottom: "20px" }}>
                        <Row gutter={[16]} >
                            <Col span={6}>
                                <Tooltip placement="top" title={this.state.esBarra ? "Barra" : "Punto de venta"}>
                                    <div className="center">
                                        {
                                            this.state.esBarra
                                                ? "Barra:"
                                                : "Punto de venta:"
                                        }
                                    </div>
                                    <InputNumber type="text" value={this.state.sucursal} disabled={true} style={{ width: '200px' }} />
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={(_, index) => index}
                            columns={columnasArticulos}
                            dataSource={this.state.arrArticulosVista}
                            pagination={false}
                            scroll={this.state.scroll}
                        />
                        <Pagination style={{ float: 'right', margin: '16px 0' }} defaultCurrent={1} onChange={(page, pageSize) => this.onChangePagination(page, pageSize)} pageSize={100} total={this.state.totalArticulos} size={'small'}></Pagination>
                    </Spin>
                    <Modal
                        title={<p style={{ textAlign: "center", marginBottom: 0 }}>Aviso sobre artículos</p>}
                        onCancel={() => { this.setState({ mostrar_modal_articulos: false, bloquear_guardar: true }) }}
                        centered={true}
                        width={"90%"}
                        visible={this.state.mostrar_modal_articulos}
                        maskClosable={false}
                        footer={null}
                    >
                        <p style={{ textAlign: 'center' }}>
                            <span style={{ backgroundColor: "#82aef086" }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            &nbsp;Recuadro azul artículos que presentan un sobrante en tu inventario &nbsp;&nbsp;

                            <span style={{ backgroundColor: "#ffe0e0" }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            &nbsp;Recuadro rojo artículos que presentan un faltante en tu inventario
                        </p>
                        <p style={{ textAlign: 'center', fontWeight: "bold" }}>
                           Venta neta mes anterior&nbsp;
                           <span style={{fontSize: "16px"}}>{this.currencyFormat(this.state.ventaNeta)}</span> &nbsp;&nbsp;&nbsp;
                           Diferencia total (estimada) de inventario en dinero&nbsp;
                           <span style={{fontSize: "16px"}}>{this.currencyFormat(this.state.difereniaNeta)}</span> &nbsp;&nbsp;&nbsp;
                           Porcentaje diferencia inventarios vs venta&nbsp;
                           <span style={{fontSize: "16px", color: this.state.difereniaPrcnt <= -0.6 ? '#E74C3C' : (this.state.difereniaPrcnt > 0 ? '#070bfaff' : '#000000ff')}}>{this.financial(this.state.difereniaPrcnt)} %</span> &nbsp;&nbsp;&nbsp;
                        </p>
                        
                        <Spin
                            tip="Cargando..."
                            indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                            spinning={this.state.cargando}
                            style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                            <div id="divTable" style={{ height: "500px" }}>
                                <Table
                                    size="small"
                                    pagination={false}
                                    locale={{ emptyText: 'No se han encontrado resultados.' }}
                                    rowKey={(_, index) => index}
                                    columns={columnasCodigos}
                                    dataSource={this.state.arrArticulosVistaRec}
                                    rowClassName={this.getRowClassName}
                                    scroll={{ y: 450 }}
                                />
                            </div>
                            <Pagination style={{ float: 'right', margin: '16px 0' }} defaultCurrent={1} onChange={(page, pageSize) => this.onChangePaginationRec(page, pageSize)} pageSize={100} total={this.state.totalArticulosRec} size={'small'}></Pagination>
                        </Spin>
                        <br></br>
                        <div style={{ textAlign: "right", width: "100%" }}>
                            <Button
                                className="btnVerCrearGuardar"
                                type="primary"
                                id="boton-guardar-inventario-modulo"
                                disabled={this.state.bloquear_guardar}
                                onClick={() => { this.showConfirmProcces() }}
                            > Procesar Inventario </Button>
                        </div>
                    </Modal>

                    <Modal
                        title={<p style={{ textAlign: "center", marginBottom: 0 }}>Aviso sobre Pedidos</p>}
                        onCancel={() => { this.setState({ mostrar_modal_po: false }) }}
                        centered={true}
                        width={"70%"}
                        visible={this.state.mostrar_modal_po}
                        maskClosable={false}
                        footer={null}
                    >
                        <p style={{ textAlign: 'center' }}>
                            Los siguientes pedidos se encuentran en estatus Embarcado, por este motivo no se permite capturar un nuevo inventario.
                        </p>
                        <Table
                            size="small"
                            pagination={{ showTitle: false }}
                            locale={{ emptyText: 'No se han encontrado resultados.' }}
                            rowKey={(_, index) => index}
                            columns={columnPedidos}
                            dataSource={this.state.arr_pedidos}
                        />
                    </Modal>
                </div>
            </Card>
        )
    }
}